export const setNetworksReducer = (prev, update) => {
    return { ...prev, Networks: update.networks };
};
export const setBoundsReducer = (prev, update) => {
    return { ...prev, bounds: update.bounds };
};
export const setParametersReducer = (prev, update) => {
    return { ...prev, parameters: update.params };
};
export const setAreaDataReducer = (prev, update) => {
    return { ...prev, areaData: update.areaDatas };
};
export const setPropertiesReducer = (prev, update) => {
    return { ...prev, Properties: update.properties };
};
export const setAreasReducer = (prev, update) => {
    return { ...prev, Areas: update.areas };
};
export const setPlacesReducer = (prev, update) => {
    return { ...prev, Places: update.places };
};
export const setCoverageTargetsReducer = (prev, update) => {
    let ret = { ...prev };
    if (update.areas) {
        ret = setAreasReducer(ret, { type: 'setAreas', areas: update.areas });
    }
    if (update.places) {
        ret = setPlacesReducer(ret, { type: 'setPlaces', places: update.places });
    }
    if (update.properties) {
        ret = setPropertiesReducer(ret, { type: 'setProperties', properties: update.properties });
    }
    return ret;
};
export const setLineDefiningPairsReducer = (prev, update) => {
    return { ...prev, lineDefiningPairs: update.lineDefiningPairs };
};
